export enum DebtType {
    CarLoan,
    MortgageLoan,
    ConsumerLoan,
    CreditCard,
    StudentLoan
}
